import config from "../lib/config";
import client from "./client";

export const getCurrentUser = () => {
    const response = client.get(config.api.url + "/api/user");
    return response;
};

export const loginUser = (email, password) => {
    const response = client.post(config.api.url + "/api/login", { email, password });
    return response;
};

export const getUsers = (params, opts = {}) => {
    const response = client.get(config.api.url + "/api/users", { params: params, cancelToken: opts.cancelToken });
    return response;
};

export const getUser = (id) => {
    const response = client.get(config.api.url + "/api/users/" + id);
    return response;
}

export const updateUser = (id, data) => {
    const response = client.put(config.api.url + "/api/users/" + id, data);
    return response;
}

export const deleteUser = (id, params = {}) => {
    const response = client.delete(config.api.url + "/api/users/" + id, { params: params });
    return response;
}

export const createUser = (data, params = {}) => {
    const response = client.post(config.api.url + "/api/users", data);
    return response;
}

export const getUserToken = (id) => {
    const response = client.get(config.api.url + "/api/users/" + id + "/token");
    return response;
}

export const initiateEmailChange = (id, data) => {
    const response = client.post(config.api.url + "/api/users/" + id + "/initiate-email-change", data);
    return response;
}

export const confirmEmailChange = (data) => {
    const response = client.post(config.api.url + "/api/confirm-email-change", data);
    return response;
}
